import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';
import InfoOutlineRoundedIcon from '@mui/icons-material/InfoOutlineRounded';
import clsx from 'clsx';
import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { REACTIONS } from '../../../../constants';
import Id8Image from '../id8-image/Id8Image';
import SlideButton from '../slide-button/SlideButton';

import scss from './FrameSlider.module.scss';

function PreviewSlide({ slide, onLike, onDownload, idea, disabled, onShowSourceImage }) {
  const { t } = useTranslation('id8');

  const [backgroundImage, setBackgroundImage] = useState(null);

  const handleLike = () => {
    if (onLike && !disabled) {
      onLike(slide);
    }
  };

  const handleDownload = () => {
    if (onDownload && !disabled) {
      onDownload(slide.id);
    }
  };

  const handleShowSource = () => {
    if (!disabled) {
      onShowSourceImage(slide);
    }
  };

  const handleImageLoaded = (url) => {
    setBackgroundImage(url);
  };

  return (
    <div className={scss.previewSlide}>
      <img src={backgroundImage} alt='preview' aria-hidden='true' className={scss.previewSlideBackground} />

      <Id8Image
        imageId={slide.id}
        idea={idea}
        className={scss.previewSlideImage}
        disabled={disabled}
        onImageLoaded={handleImageLoaded}
      />

      <div className={scss.buttonsGroup}>
        {onShowSourceImage && (
          <SlideButton
            icon={InfoOutlineRoundedIcon}
            onClick={handleShowSource}
            ariaLabel='Show source image'
            tooltip={t('sourceImage')}
            disabled={disabled}
          />
        )}
        {onDownload && (
          <SlideButton
            icon={DownloadOutlinedIcon}
            onClick={handleDownload}
            ariaLabel='Download this picture'
            disabled={disabled}
          />
        )}
        {onLike && (
          <SlideButton
            icon={slide.reaction === REACTIONS.LIKE ? FavoriteOutlinedIcon : FavoriteBorderOutlinedIcon}
            onClick={handleLike}
            ariaLabel='Like this picture'
            className={clsx(slide.reaction === REACTIONS.LIKE && scss.favoriteSlide)}
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
}

export default memo(PreviewSlide);
